<template>
  <div class="project-group-wrap">
    <div class="card-header">项目</div>
    <div class="btn-group">
      <el-button icon="el-icon-plus" type="primary" @click="addProjectGroup">新建项目</el-button>
      <el-button icon="el-icon-plus" class="def-btn" @click="hasProjectGroup">已有项目</el-button>
    </div>
    <div class="newgroup-wrap" style="padding-top: 20px" v-if="dialogVisible">
      <ul class="modal-form">
        <el-form :model="formData" :rules="rules" ref="ruleForm">
          <li class="form-item">
            <span class="form-label">项目名称：</span>
            <div class="form-value">
              <el-form-item prop="name">
                <el-input
                  maxlength="50"
                  show-word-limit
                  style="max-width: 770px"
                  placeholder="(必填)请输入项目名称"
                  v-model="formData.name"
                >
                </el-input>
              </el-form-item>
              <ul class="name-list">
                <li
                  v-for="(item, index) of showAdList"
                  :key="index"
                  :class="['name-item', selectItem.indexOf(index) === -1 ? '' : 'cur']"
                  @click="handleSelectItem(item, index)"
                >
                  {{ item }}
                </li>
                <li class="show-more">
                  <span v-show="!showMore" @click="showMore = true">更多<i class="el-icon-arrow-down"></i></span>
                  <span v-show="showMore" @click="showMore = false">收起<i class="el-icon-arrow-up"></i></span>
                </li>
              </ul>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label" style="padding-top: 0px">投放时间：</span>
            <div class="form-value">
              <el-radio-group v-model="formData.schedule_type" style="display: block">
                <el-radio label="SCHEDULE_FROM_NOW">从今天到长期投放</el-radio>
                <el-radio label="SCHEDULE_START_END">设置开始和结束日期</el-radio>
              </el-radio-group>
              <el-form-item prop="time">
                <el-date-picker
                  v-if="formData.schedule_type === 'SCHEDULE_START_END'"
                  v-model="formData.time"
                  type="daterange"
                  align="right"
                  unlink-panels
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :clearable="false"
                  :picker-options="pickerOptions"
                  style="width: 320px; margin-top: 8px"
                ></el-date-picker>
              </el-form-item>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label" style="padding-top: 0px">投放时段：</span>
            <div class="form-value" style="display: block">
              <el-radio-group v-model="formData.schedule_mode">
                <el-radio label="None">不限</el-radio>
                <el-radio label="SpecifyTime">指定时间段</el-radio>
              </el-radio-group>
              <div class="time-range-wrap" v-show="formData.schedule_mode === 'SpecifyTime'">
                <time-table ref="timeTableRef"></time-table>
              </div>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label" style="padding-top: 0px">竞价策略：</span>
            <div class="form-value">
              <el-radio-group v-model="formData.bid_type" @change="changeBidType">
                <el-radio label="CUSTOM">稳定成本</el-radio>
                <el-radio label="NO_BID" :disabled="isShowDeepBid">最大转化</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label" style="padding-top: 0px">项目预算：</span>
            <div class="form-value">
              <el-radio-group v-model="formData.budget_mode">
                <el-radio label="BUDGET_MODE_INFINITE">不限</el-radio>
                <el-radio label="BUDGET_MODE_DAY">指定预算</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item" v-if="formData.budget_mode === 'BUDGET_MODE_DAY' && formData.bid_type === 'NO_BID'">
            <span class="form-label" style="padding-top: 0px">预算择优分配：</span>
            <div class="form-value">
              <el-radio-group v-model="formData.budget_optimization" @change="changeBidType">
                <el-radio label="ON">启用</el-radio>
                <el-radio label="OFF">不启用</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item" style="margin-bottom: 0px" v-if="formData.budget_mode === 'BUDGET_MODE_DAY'">
            <span class="form-label">日预算：</span>
            <div class="form-value">
              <el-form-item prop="budget">
                <el-input @change="changeBidType" style="width: 300px" placeholder="(必填) >= 300" v-model="formData.budget">
                  <template slot="append">CNY</template>
                </el-input>
              </el-form-item>
            </div>
          </li>
        </el-form>
      </ul>
    </div>
    <div class="table-wrap" v-else>
      <el-table :data="projectGroupTable" style="width: 100%" v-loading="tableLoading">
        <el-table-column prop="name" label="项目名称"> </el-table-column>
        <el-table-column prop="adCount" label="广告账号">
          <template>
            {{ adCount }}
          </template>
        </el-table-column>
        <el-table-column prop="start_time" label="投放时间"> </el-table-column>
        <el-table-column prop="bid_type" label="竞价策略">
          <template slot-scope="scope">
            {{ scope.row.bid_type === "CUSTOM" ? "稳定成本" : "最大转化" }}
          </template>
        </el-table-column>
        <el-table-column label="组预算">
          <template slot-scope="scope">
            <div class="show-wrap">
              <span class="show-label">日预算：</span>
              <span class="budget-value">{{ scope.row.budget_mode === "BUDGET_MODE_INFINITE" ? "不限" : scope.row.budget }}</span>
              <el-popover v-model="showPopover" placement="bottom" width="238" trigger="manual">
                <div class="edit-budget-wrap">
                  <span style="font-size: 14px; color: rgba(0, 0, 0, 0.65)">预算：</span>
                  <el-radio-group v-model="scope.row.budget_mode">
                    <el-radio label="BUDGET_MODE_INFINITE">不限</el-radio>
                    <el-radio label="BUDGET_MODE_DAY">指定预算</el-radio>
                  </el-radio-group>
                  <el-form :rules="popoverRule" :model="scope.row" :ref="'ref' + scope.row.project_id">
                    <el-form-item prop="edit_budget" v-show="scope.row.budget_mode === 'BUDGET_MODE_DAY'">
                      <el-input style="margin-top: 10px" v-model="scope.row.budget" placeholder="请输入日预算"></el-input>
                    </el-form-item>
                  </el-form>

                  <div class="button-wrap" style="text-align: right; margin-top: 16px">
                    <el-button @click="showPopover = false" style="height: 26px" size="mini">取消</el-button>
                    <el-button style="height: 26px" size="mini" type="primary" @click="editConfirm('ref' + scope.row.project_id)"
                      >确定</el-button
                    >
                  </div>
                </div>
                <template slot="reference">
                  <svg-icon iconClass="pen" className="icon" @click="setCur(scope.row)"></svg-icon>
                </template>
              </el-popover>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 已有项目弹框 -->
    <el-dialog title="已有项目" :visible.sync="showHasModal" width="800px" @opened="openHasModal">
      <div class="modal-body">
        <el-input v-model="searchName" style="width: 300px; margin-bottom: 12px" placeholder="请输入项目" @change="searchProject">
        </el-input>
        <div class="transfer-wrap">
          <el-table :data="projectList" v-loading="modalLoading" style="width: 100%" max-height="500px">
            <el-table-column prop="project_id" label="项目ID"> </el-table-column>
            <el-table-column prop="name" label="项目名称"> </el-table-column>
            <el-table-column prop="package_name" label="应用包名"> </el-table-column>
            <el-table-column prop="operate" label="操作" width="100px">
              <template slot-scope="scope">
                <el-button type="text" @click="confirmeSelect(scope.row)">使用该项目</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="footer-wrap">
          <self-pagination
            :total="projectPageData.total"
            :pageSize="projectPageData.size"
            :currentPage="projectPageData.page"
            ref="tabelPagination"
            @getCurrentPage="changeProjectPage"
          ></self-pagination>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TimeTable from "@/components/timeTable.vue";
import { getTtV2ProjectList } from "@/api/promotion.js";
import SvgIcon from "@/components/SvgIcon.vue";
import nameTransforUtil from "./common/nameTransforUtil.js";
export default {
  components: {
    SvgIcon,
    TimeTable,
    
  },
  data() {
    return {
      dialogVisible: true, //是否展示新建表单
      showHasModal: false,
      modalLoading: false,
      selectItem: [],
      projectNameList: [
        "推广目标",
        "应用名称",
        "创建日期",
        "预算类型",
        "投放范围",
        "广告位置",
        "投放形式",
        "转化名称",
        "账户备注名",
        "首个视频名称",
        "首个图片名称",
      ],
      showMore: true,
      formData: {
        name: "",
        schedule_type: "SCHEDULE_FROM_NOW",
        time: [],
        schedule_mode: "None",
        bid_type: "CUSTOM",
        budget_mode: "BUDGET_MODE_DAY",
        budget_optimization: "ON",
        budget: "",
      },
      projectPageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      searchName: "",
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 3600 * 24 * 1000;
        },
      },
      rules: {
        budget: [{ validator: this.checkBudget, trigger: ["blur", "change"] }],
        name: [
          {
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (value === "" && this.dialogVisible === true) {
                callback(new Error("项目名称必填"));
              } else {
                callback();
              }
            },
          },
        ],
        time: [
          {
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (value?.length < 2 && this.formData.schedule_type === "SCHEDULE_START_END") {
                callback(new Error("投放时间必填"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      //已有弹框相关内容****************************************************
      curId: null,
      projectList: [],
      projectGroupTable: [],
      curEdit: {}, //当前编辑的数据
      showPopover: false,
      tableLoading: false,
      popoverRule: {
        edit_budget: [
          {
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (this.curEdit.budget_mode === "BUDGET_MODE_INFINITE") {
                callback();
              } else if (this.curEdit.budget === "") {
                callback(new Error("请输入日预算"));
              } else if (!/^[0-9]*$/.test(this.curEdit.budget) || Number(this.curEdit.budget) < 300) {
                callback(new Error("请输入不小于300的数字"));
              } else {
                callback();
              }
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.addSaveInStore();
  },
  methods: {
    addProjectGroup() {
      if (!this.dialogVisible) {
        this.dialogVisible = true;
        this.$store.commit("set_project_delivery_setting", null);
        this.$store.commit("set_already_projectID", null);
      }
    },
    checkBudget(rule, value, callback) {
      if (this.dialogVisible === false || this.formData.budget_mode === "BUDGET_MODE_INFINITE") {
        callback();
      } else if (value === "") {
        callback(new Error("请输入日预算"));
      } else if (!/^[0-9]*$/.test(value) || Number(value) < 300) {
        callback(new Error("请输入不小于300的数字"));
      } else {
        callback();
      }
    },
    handleSelectItem(item, itemIndex) {
      let index = this.selectItem.findIndex((item) => item === itemIndex);
      if (index === -1) {
        this.selectItem.push(itemIndex);
        this.formData.name += "{" + item + "}";
      } else {
        this.selectItem.splice(index, 1);
        this.formData.name = this.formData.name.replace("{" + item + "}", "");
      }
    },
    //选择已有相关*********************************************************
    hasProjectGroup() {
      if (!this.adCount) {
        this.$alert("请选择广告账号后再操作", "提示", {
          confirmButtonText: "确定",
        });
      } else {
        this.showHasModal = true;
      }
    },
    openHasModal() {
      this.curId = this.adCount;
      this.projectPageData.page = 1;
      this.searchName = "";
      this.getProjectList();
    },
    getProjectList() {
      this.modalLoading = true;
      getTtV2ProjectList({
        advertiserId: this.adCount,
        page: this.projectPageData.page,
        pageSize: this.projectPageData.size,
        name: this.searchName,
      }).then((res) => {
        this.modalLoading = false;
        if (res.code === "0000") {
          this.projectList = res.data.projectList;
          this.projectPageData.total = res.data.totalNum;
        }
      });
    },
    searchProject() {
      this.projectPageData.page = 1;
      this.getProjectList();
    },
    changeProjectPage(page) {
      this.projectPageData.page = page;
      this.getProjectList();
    },
    //选择已有确定
    confirmeSelect(data) {
      if (data.project_id) {
        let projectGroup = [];
        const item = this.projectList.find((child) => child.project_id === data.project_id);
        projectGroup.push(item);
        this.showHasModal = false;
        this.dialogVisible = false;
        //保存到store
        this.$store.commit("set_project_delivery_setting", item.delivery_setting);
        this.$store.commit("set_already_projectID", item.project_id);
        this.$store.commit("setcheckedApp_ttV2", item.convertProduct);
        // 人群包
        this.$store.commit("set_audience_ttV2", [item.audience]);
        //定向包
        this.$store.commit("set_targeting_ttV2", [item.targeting]);
        // 设置基础设置-优化目标
        this.$store.commit("set_optimize_goal_ttV2", item.optimize_goal);
        //设置基础设置-投放位置
        this.$store.commit("set_deliveryRange_ttV2", item.delivery_range);
        //其他配置
        this.$store.commit("set_trackUrl_setting_ttV2", item.track_url_setting);
      } else {
        this.$message({
          message: "请选择项目",
          type: "warning",
        });
      }
    },
    // 已有项目保存到store
    saveInstore() {
      const storeData = JSON.parse(JSON.stringify(this.projectGroupTable[0]));
      this.$store.commit("set_project_delivery_setting", storeData);
    },
    // 新建项目保存到store
    addSaveInStore() {
      if (this.dialogVisible) {
        //保存新建的项目表单数据到store
        const data = JSON.parse(JSON.stringify(this.formData));
        const { schedule_type, time, schedule_mode, name } = data;
        if (schedule_type === "SCHEDULE_START_END" && time?.length > 1) {
          data.start_time = time[0];
          data.end_time = time[1];
        }
        if (schedule_mode === "SpecifyTime") {
          data.schedule_time = this.$refs.timeTableRef.checkedValue.join("");
        } else {
          data.schedule_time = "";
        }
        data.name = nameTransforUtil.showDataToApi(name);
        delete data.time;
        this.$store.commit("set_project_delivery_setting", data);
      } else {
        //添加广告账户数据到已有项目数据中
        const deliverySetting = JSON.parse(JSON.stringify(this.deliverySetting));
        this.$store.commit("set_project_delivery_setting", deliverySetting);
      }
    },
    checkData() {
      return new Promise((resolve, reject) => {
        if (this.dialogVisible) {
          this.$refs.ruleForm.validate((valid) => {
            if (valid) {
              this.addSaveInStore();
              resolve();
            } else {
              reject();
            }
          });
        } else {
          this.addSaveInStore();
          resolve();
        }
      });
    },
    editConfirm(refName) {
      this.$refs[refName].validate((valid) => {
        if (valid) {
          this.showPopover = false;
          this.projectGroupTable.map((item) => {
            item.budget = Number(this.curEdit.budget);
            item.budget_mode = this.curEdit.budget_mode;
            return item;
          });
          this.saveInstore();
        }
      });
    },
    changeBidType() {
      this.addSaveInStore();
    },
    setCur(data) {
      this.curEdit = data;
      this.showPopover = true;
    },
  },
  computed: {
    showAdList() {
      if (!this.showMore) {
        return this.projectNameList.slice(0, 6);
      }
      return this.projectNameList;
    },
    ...mapState({
      adCount: (state) => state.PromotionTtV2.baseData.advertiser_id,
      alreadyProjectId: (state) => state.PromotionTtV2.baseData.projectId,
      deliverySetting: (state) => state.PromotionTtV2.deliverySetting,
      optimizeGoal: (state) => state.PromotionTtV2.optimizeGoal,
    }),
    isShowDeepBid() {
      return this.optimizeGoal && this.optimizeGoal.deep_external_action && this.optimizeGoal.deep_external_action !== "NONE";
    },
  },
  watch: {
    deliverySetting: {
      handler(value) {
        if (this.alreadyProjectId) {
          this.dialogVisible = false;
          this.projectGroupTable = [];
          this.projectGroupTable.push(value);
        } else {
          this.dialogVisible = true;
          const data = JSON.parse(JSON.stringify(value));
          const { schedule_type, start_time, end_time, schedule_mode, schedule_time, name } = data;
          if (schedule_type === "SCHEDULE_START_END") {
            data.time = [start_time, end_time];
          }
          if (schedule_mode === "SpecifyTime") {
            this.$refs.timeTableRef.showSelectNode(schedule_time.split("").map((item) => Number(item)));
          } else {
            this.$refs.timeTableRef && this.$refs.timeTableRef.clearSelect();
          }
          if (name) {
            data.name = nameTransforUtil.apiDatatoShow(name);
          }
          this.selectItem = [];
          this.projectNameList.map((item, index) => {
            if (data.name.includes(`{${item}}`)) {
              this.selectItem.push(index);
            }
          });
          this.formData = data;
        }
      },
      deep: true,
      immediate: true,
    },
    "optimizeGoal.deep_external_action": {
      handler() {
        if (this.isShowDeepBid) {
          this.formData.bid_type = "CUSTOM";
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.project-group-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-weight: bold;
  }
  .btn-group {
    margin-top: 16px;
    .def-btn {
      color: rgba(24, 144, 255, 1);
      border: 1px solid rgba(24, 144, 255, 1);
    }
  }
  .table-wrap {
    margin-top: 16px;
    .show-wrap {
      font-size: 14px;
      .show-label {
        color: rgba(0, 0, 0, 0.65);
      }
      .budget-value {
        color: rgba(0, 0, 0, 0.85);
      }
      .icon {
        cursor: pointer;
        margin-left: 8px;
      }
    }
  }
  .newgroup-wrap,
  .modal-body {
    .modal-form {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 16px;
        /deep/.el-form-item__error {
          top: 11px;
          left: 330px;
        }
        /deep/ .el-form-item {
          margin-bottom: 6px;
        }
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 110px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          padding-top: 6px;
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          .list-wrap {
            max-height: 120px;
            overflow: auto;
            .adCountItem {
              height: 22px;
              line-height: 22px;
              border-radius: 2px;
              display: inline-block;
              padding: 0 8px;
              margin: 0 8px 8px 0;
              background: rgba(233, 233, 233, 0.6);
              color: rgba(0, 0, 0, 0.65);
              .close-btn {
                display: inline-block;
                margin-left: 6px;
                font-size: 18px;
                cursor: pointer;
                position: relative;
                top: 1px;
              }
            }
          }
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(24, 144, 255, 1);
          }
          /deep/ .el-input-group__append,
          /deep/ .el-input-group__prepend {
            background-color: #fff;
            color: rgba(0, 0, 0, 0.85);
            padding: 0 10px;
          }
          .name-list {
            padding: 12px 0px 0px 0px;
            margin: 0px;
            list-style: none;
            display: flex;
            flex-wrap: wrap;
            .name-item {
              border-radius: 2px;
              border: 1px solid transparent;
              box-sizing: border-box;
              background: rgba(233, 233, 233, 0.6);
              color: rgba(0, 0, 0, 0.85);
              font-size: 12px;
              padding: 2px 6px;
              margin: 0 8px 8px 0px;
              cursor: pointer;
              &.cur {
                border: 1px solid rgba(24, 144, 255, 1);
                background: rgba(225, 240, 255, 1);
                color: rgba(24, 144, 255, 1);
              }
            }
            .show-more {
              color: rgba(24, 144, 255, 1);
              font-size: 13px;
              cursor: pointer;
              margin-left: 20px;
              line-height: 24px;
              i {
                margin-left: 4px;
              }
            }
          }
        }
      }
    }
    .footer-wrap {
      text-align: right;
      display: block;
      padding-bottom: 24px;
    }
    .transfer-wrap {
      display: flex;
      margin-bottom: 24px;
      .top-list {
        width: 250px;
        border: 1px solid #ebeef5;
        .list-header {
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          padding: 10px 0px 10px 12px;
          border-bottom: 1px solid #ebeef5;
        }
        .count-list {
          overflow: auto;
          height: 316px;
          padding: 0px;
          margin: 0px;
          list-style: none;
          .count-item {
            cursor: pointer;
            padding: 6px 10px;
            position: relative;
            .item-detial {
              display: block;
              font-size: 12px;
              color: #666;
            }
            &.cur {
              background-color: rgba(230, 247, 255, 1);
            }
          }
          .item-count {
            position: absolute;
            right: 10px;
            top: 11px;
            width: 17px;
            height: 17px;
            border-radius: 3px;
            background: rgba(24, 144, 255, 1);
            color: rgba(255, 255, 255, 1);
            font-size: 14px;
            text-align: center;
            line-height: 17px;
          }
        }
      }
      /deep/ .el-checkbox {
        margin-right: 0px;
      }
    }
  }
}
</style>
